import { Menu } from 'generated/graphql';
import React from 'react';
import { useCategoryContext } from 'components/CategoryList/CategoryContext';

type Props = {
  menu: Menu;
  reset: () => void;
};

const TestDragSimulator: React.FC<Props> = ({ menu, reset }) => {
  const { addChangedCategoryIds } = useCategoryContext();

  const handleClick = (): void => {
    addChangedCategoryIds([menu.categories[0].mmId]);
  };

  return (
    <>
      <button type="button" onClick={handleClick} data-testid="test-drag-simulator-button">
        Test Drag Simulator
      </button>
      <button type="button" onClick={reset} data-testid="test-drag-simulator-reset-button">
        Test Reset
      </button>
    </>
  );
};

export default TestDragSimulator;
